import {translator} from "../services/TranslatorService";

export class TooltipInfo {
	constructor() {
		this.$tooltip = $("#js-tooltip-info");
	}

	/**
	 * Показывет тултип над элементом
	 */
	show() {
		this.$tooltip.show();
	}

	hide() {
		this.$tooltip.hide();
		this.$tooltip.css({ left: 0, top: 0 });
	}

	/**
	 * Создает тултип
	 * Изменяйте или модифицируйте тултип через передачу аргументов!
	 * @param data {Object}
	 */
	createTooltip(data) {
		this.setPositionByElement(data.$element);

		this.$tooltip.find(".tooltip-info__name").text(`${data.name ? translator.t("event", "Sector") : ""} ${data.name ? data.name : ""}`);
		this.$tooltip.find(".tooltip-info__available").text("");
		this.$tooltip.find(".tooltip-info__count").text("");
		if (data.free) {
			this.$tooltip
				.find(".tooltip-info__available")
				.text(`${translator.t("main", "Free")} ${data.free}`);
			if (data.all) {
				this.$tooltip
					.find(".tooltip-info__count")
					.text(`${translator.t("event", "from")} ${data.all}`);
			}
		}

		if (data.price)
			this.$tooltip
				.find(".tooltip-info__price")
				.text(`${translator.t("order", "Price")} ${data.price}`);
	}

	setPositionByElement(element) {
		const elementRect = element[0].getBoundingClientRect();

		const clientX =
			elementRect.x || elementRect.left;
		const clientY =
			elementRect.y || elementRect.top;

		const modal = this.$tooltip.parents(".modal");
		let y = clientY - this.$tooltip.outerHeight();

		if (modal.length) {
			y -= modal[0].getBoundingClientRect().top;
		}
		if (modal.scrollTop() > 0) {
			y += modal.scrollTop();
		}
		const x =
			clientX - this.$tooltip.outerWidth() / 2 + elementRect.width / 2;

		this.$tooltip.css({ left: x, top: y });
	}
}
